module.exports = __webpack_public_path__ + "img/icon_3.6b4f8a77.svg";